// @TODO <HEALTH2019>
App.filter('healthInsuranceTypeFilter', function () {
    var dictionary = {
        REHABILITATION: 'Rehabilitacja',
        VIP: 'VIP',
        FULL: 'Pełny',
        EXPANDED: 'Rozszerzony',
        BASIC: 'Podstawowy',
    };

    return function (el) {
        if(!el){
            return el;
        }

        return dictionary[el] || el;
    };
});
// @TODO </HEALTH2019>
